import React, { useRef } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaGithub, FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = ({ currentTheme }) => {
  const form = useRef();

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ebp62no', 'template_bmcodie', form.current, 'Su9XMyETgOapE2iIl')
      .then((result) => {
        toast.success('Message sent successfully!');
        form.current.reset();
      }, (error) => {
        toast.error('Failed to send message. Please try again.');
      });
  };

  return (
    <Container fluid className="py-5 position-relative overflow-hidden" id='contact' style={{ backgroundColor: currentTheme.background }}>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      
      {/* Background animation */}
      <div className="position-absolute w-100 h-100 top-0 start-0" style={{ zIndex: -1 }}>
        <motion.div
          animate={{
            background: [
              `linear-gradient(45deg, ${currentTheme.primary} 0%, ${currentTheme.secondary} 100%)`,
              `linear-gradient(45deg, ${currentTheme.secondary} 0%, ${currentTheme.primary} 100%)`
            ],
          }}
          transition={{ duration: 3, repeat: Infinity, repeatType: 'reverse' }}
          className="w-100 h-100"
        />
      </div>

      <Container className="position-relative">
        {/* Header */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            animate={{
              y: [-5, 5, -5],
              transition: { duration: 2, repeat: Infinity }
            }}
            className="mb-3"
          >
            <FaPaperPlane style={{ color: currentTheme.primary }} className="display-1" />
          </motion.div>
          <h2 className="display-4 fw-bold mb-1" style={{ color: currentTheme.primary }}>CONTACT</h2>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <div style={{ backgroundColor: currentTheme.primary, height: '2px', width: '30px' }}></div>
            <FaPaperPlane style={{ color: currentTheme.primary }} />
            <div style={{ backgroundColor: currentTheme.primary, height: '2px', width: '30px' }}></div>
          </div>
        </motion.div>

        <Row className="gy-4">
          {/* Contact Information */}
          <Col lg={6}>
            <motion.div {...fadeInUp}>
              <h4 className="fw-bold mb-4" style={{ color: currentTheme.text }}>About Me</h4>
              <div className="d-flex align-items-center mb-3">
                <div style={{ backgroundColor: `rgba(${currentTheme.primary}, 0.1)` }} className="p-3 rounded-circle me-3">
                  <FaPhone style={{ color: currentTheme.primary }} />
                </div>
                <div>
                  <h5 className="fw-bold mb-1 fs-6 lh-base" style={{ color: currentTheme.text }}>Phone</h5>
                  <p className="fs-6 lh-base" style={{ color: currentTheme.text }}>+254701043391</p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div style={{ backgroundColor: `rgba(${currentTheme.primary}, 0.1)` }} className="p-3 rounded-circle me-3">
                  <FaEnvelope style={{ color: currentTheme.primary }} />
                </div>
                <div>
                  <h5 className="fw-bold mb-1 fs-6 lh-base" style={{ color: currentTheme.text }}>Email</h5>
                  <p className="fs-6 lh-base" style={{ color: currentTheme.text }}>somondi398@gmail.com</p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div style={{ backgroundColor: `rgba(${currentTheme.primary}, 0.1)` }} className="p-3 rounded-circle me-3">
                  <FaGithub style={{ color: currentTheme.primary }} />
                </div>
                <div>
                  <h5 className="fw-bold mb-1 fs-6 lh-base" style={{ color: currentTheme.text }}>GitHub</h5>
                  <p className="fs-6 lh-base" style={{ color: currentTheme.text }}>OMONDISOFTWAREENGINEER</p>
                </div>
              </div>
            </motion.div>
          </Col>

          {/* Contact Form */}
          <Col lg={6}>
            <motion.div {...fadeInUp}>
              <h4 className="fw-bold mb-4" style={{ color: currentTheme.text }}>Get in Touch</h4>
              <Form ref={form} onSubmit={sendEmail}>
                <Form.Group className="mb-3">
                  <Form.Label className="fs-6 lh-base" style={{ color: currentTheme.text }}>Name</Form.Label>
                  <Form.Control type="text" name="user_name" placeholder="Your Name" required style={{ backgroundColor: currentTheme.background, color: currentTheme.text }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fs-6 lh-base" style={{ color: currentTheme.text }}>Email</Form.Label>
                  <Form.Control type="email" name="user_email" placeholder="your.email@example.com" required style={{ backgroundColor: currentTheme.background, color: currentTheme.text }} />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="fs-6 lh-base" style={{ color: currentTheme.text }}>Message</Form.Label>
                  <Form.Control as="textarea" name="message" rows={3} placeholder="Your message here..." required style={{ backgroundColor: currentTheme.background, color: currentTheme.text }} />
                </Form.Group>
                <button type="submit" className="btn w-100" style={{ backgroundColor: currentTheme.secondary, color: currentTheme.background }}>
                  Send Message
                </button>
              </Form>
            </motion.div>
          </Col>
        </Row>

        {/* Floating icon animation */}
        <motion.div
          animate={{
            rotate: 360,
            transition: { duration: 20, repeat: Infinity, ease: "linear" }
          }}
          className="position-absolute"
          style={{ top: '10%', right: '5%', opacity: 0.1 }}
        >
          <FaPaperPlane style={{ fontSize: '4rem', color: currentTheme.primary }} />
        </motion.div>
      </Container>
    </Container>
  );
};

export default Contact;